import angular from 'angular';

import TabContentComponent from './components/tab-content/tab-content-component';
import TabHeaderComponent from './components/tab-header/tab-header-component';

export default angular
  .module('sms-notifications-tab', ['email-notifications-tab'])
  .component('smsNotificationsTabHeader', new TabHeaderComponent())
  .component('smsNotificationsTabContent', new TabContentComponent());



// WEBPACK FOOTER //
// ./src/modules/sms/components/sms-notification-templates/components/sms-notification-tab/sms-notification-tab-component.js